<script>

    export default {
        props: ['userprop', 'purchaseprop', 'purchaseelementsprop'],
        data() {
            return {
                user: {},
                purchase: {},
                purchaseElements: [],
                vouchers: []
            }
        },
        computed: {
            defaultElements() {
                return this.purchaseElements.filter(i => {
                    return i.buyable_type != 'App\\CustomGiftCard'
                })
            },
            giftCards() {
                return this.purchaseElements.filter(i => i.buyable_type == 'App\\CustomGiftCard')
            }
        },
        mounted() {
            this.user = this.userprop;
            this.purchase = this.purchaseprop;
            this.purchaseElements = this.purchaseelementsprop;
            this.vouchers = _.map(this.purchaseElements, i => i.voucher)
        },
        methods: {
            getHourOfDate(date) {
                return moment(date).format('HH:mm');
            },
            getDateOfDate(date) {
                return moment(date).format('dddd, DD MMMM YYYY');
            },
            getBirthday(date) {
                return moment(date).format('DD/MM/YYYY');
            },
            getPromotionDescription(element) {
                let lessons = element.buyable.lessons > 1 ? 'lezioni' : 'lezione'
                let people = element.buyable.people > 1 ? 'persone' : 'persona'
                let lessonType = element.buyable.lesson_type == 'group' ? 'di gruppo' : 'individuale'
                return `${element.buyable.lessons} ${lessons} ${lessonType} per ${element.buyable.people} ${people}`
            },
            getCourseThumbImage(element) {
                if (element.buyable.course.course_thumb_image)
                    return element.buyable.course.course_thumb_image;
                return element.buyable.course.course_image;
            },
            isSubscription(buyable_type) {
                return buyable_type == "App\\CourseSubscription"
            },
            isReservation(buyable_type) {
                return buyable_type == "App\\Reservation"
            },
            isLessonPackage(buyable_type) {
                return buyable_type == "App\\LessonPackage"
            },
            isPromotion(buyable_type) {
                return buyable_type == "App\\CoursePromotion"
            },
            isGiftCard(buyable_type) {
                return buyable_type == "App\\CustomGiftCard"
            },
            giftCardAmount({buyable}) {
                return buyable.voucher.price
            },
            giftCardImage(giftcard) {
                return `/${giftcard.gift_card_image}`;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/PaymentSummary.vue